"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalEntities_1 = require("./globalEntities");
exports.EVERYONE = globalEntities_1.EVERYONE;
exports.INTERNET = globalEntities_1.INTERNET;
var RelationshipClass_1 = require("./RelationshipClass");
exports.RelationshipClass = RelationshipClass_1.RelationshipClass;
var IntegrationSchema_1 = require("./IntegrationSchema");
exports.IntegrationSchema = IntegrationSchema_1.IntegrationSchema;
const integrationSchemas = __importStar(require("./IntegrationSchema"));
const { IntegrationSchema, ...allSchemas } = integrationSchemas;
exports.entitySchemas = allSchemas;
exports.entityClasses = Object.keys(exports.entitySchemas);
var validateEntityWithSchema_1 = require("./validateEntityWithSchema");
exports.validateEntityWithSchema = validateEntityWithSchema_1.validateEntityWithSchema;
var getSchema_1 = require("./getSchema");
exports.getSchema = getSchema_1.getSchema;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsbURBQXNEO0FBQTdDLG9DQUFBLFFBQVEsQ0FBQTtBQUFFLG9DQUFBLFFBQVEsQ0FBQTtBQUUzQix5REFBd0Q7QUFBL0MsZ0RBQUEsaUJBQWlCLENBQUE7QUFZMUIseURBQXdEO0FBQS9DLGdEQUFBLGlCQUFpQixDQUFBO0FBRTFCLHdFQUEwRDtBQUMxRCxNQUFNLEVBQUUsaUJBQWlCLEVBQUUsR0FBRyxVQUFVLEVBQUUsR0FBRyxrQkFBa0IsQ0FBQztBQUNuRCxRQUFBLGFBQWEsR0FBRyxVQUFVLENBQUM7QUFFM0IsUUFBQSxhQUFhLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxxQkFBYSxDQUFrQixDQUFDO0FBRXpFLHVFQUFzRTtBQUE3RCw4REFBQSx3QkFBd0IsQ0FBQTtBQUNqQyx5Q0FBd0M7QUFBL0IsZ0NBQUEsU0FBUyxDQUFBIn0=